export default {
  tooltip_title: 'Click to copy',
  success: 'Copied!',
};
